<template>
  <!-- 页面名称 -->
  <div class="Box">
    <el-card class="mb5">
      <el-form class="selectClass">
        <el-row :gutter="20" style="display: flex;align-items: center">
          <el-col :span="5">
            <!-- 邮编所属州 -->
            <el-form-item :label="$t('collectionCenter.postalCodeState')">
              <el-select
                v-model="queryForm.params.state"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
                size="small"
                style="width: 100%"
                @change="getCity(queryForm.params.state)"
              >
                <el-option
                  v-for="(item, index) in twoCodeList"
                  :key="index"
                  :label="item.stateCode"
                  :value="item.stateCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 邮编所属城市 -->
            <el-form-item :label="$t('collectionCenter.postalCodeCity')">
              <ElSelectV2
                v-model="queryForm.params.city"
                :options="allCity"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                filterable
                size="small"
                style="width: 100%"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 邮编 -->
            <el-form-item :label="$t('collectionCenter.Zip')">
              <el-input
                v-model.trim="queryForm.params.zipCode" size="small" clearable
                :placeholder="$t('collectionCenter.input8ZipCode')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- 区域类型 -->
            <el-form-item :label="$t('collectionCenter.regionType')">
              <el-select
                v-model="queryForm.params.areaType"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
                size="small"
                style="width: 100%"
              >
                <el-option label="Capital" value="Capital" />
                <el-option label="Metropolitana" value="Metropolitana" />
                <el-option label="Interior 0" value="Interior 0" />
                <el-option label="Interior 1" value="Interior 1" />
                <el-option label="Interior 2" value="Interior 2" />
                <el-option label="Interior 3" value="Interior 3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" size="small" @click="search">{{ $t('newOrder.search') }}</el-button>

            <el-button type="info" size="small" @click="reset">{{ $t('collectionCenter.reset') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <el-divider />
    </el-card>
    <el-card>
      <div style="margin-bottom: 10px;">
        <el-button
          v-permit:remove="'btn:basic-data:postal-code-management:add'"
          icon="el-icon-plus" size="small"
          type="primary" @click="newAdd"
        >
          {{ $t('GlobalSetObj.add') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:basic-data:postal-code-management:import'"
          size="small" @click="importThis"
        >
          {{ $t('collectionCenter.Import') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:basic-data:postal-code-management:allExport'"
          size="small" type="primary" @click="exportAll"
        >
          {{ $t('collectionCenter.allExport') }}
        </el-button>
      </div>
      <el-table
        ref="tableRef"
        border
        :data="tableDate"
        :max-height="600"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        />
        <!-- 序号 -->
        <el-table-column
          :label="$t('mdfeTranslate.Serial')" type="index" width="60"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="state"
          align="center"
          :label="$t('mdfeTranslate.StateUF')"
        /><!-- 州 -->
        <el-table-column
          prop="city"
          align="center"
          :label="$t('collectionCenter.city')"
        /><!-- 城市 -->
        <el-table-column
          prop="startZipCodeStr"
          align="center"
          :label="$t('mdfeTranslate.StartZipCode')"
        /><!-- 起始邮编 -->
        <el-table-column
          prop="endZipCodeStr"
          align="center"
          :label="$t('mdfeTranslate.EndZipCode')"
        /><!-- 结束邮编 -->
        <el-table-column
          prop="areaType"
          align="center"
          :label="$t('collectionCenter.regionType')"
        /><!-- 区域类型 -->
        <el-table-column
          prop="riskAreaDesc"
          align="center"
          :label="$t('basicData.RiskAreas')"
        /><!-- 风险区域 -->
        <el-table-column
          prop="covered"
          align="center"
          :label="$t('collectionCenter.IsOverride')"
        /><!-- 是否覆盖 -->
        <el-table-column
          prop="ibge"
          align="center"
          label="IBGE"
        /><!-- IBGE -->
        <el-table-column
          :label="$t('GlobalSetObj.LatestModifiedBy')"
          prop="updateUserName"
          align="center"
        /><!-- 最新修改人 -->
        <el-table-column
          :label="$t('GlobalSetObj.LastModified')"
          prop="updateTime"
          align="center"
        /><!-- 最新修改时间 -->
        <el-table-column
          :label="$t('collectionCenter.operation')"
          fixed="right"
          align="center"
        >
          <template slot-scope="scope">
            <el-tooltip
              :content="$t('GlobalSetObj.edit')" class="item" effect="dark"
              placement="top"
            >
              <el-button
                v-permit:remove="'btn:basic-data:postal-code-management:edit'"
                size="mini"
                style="color: #666; margin-right: 10px"
                type="text"
                @click="edit(scope.row)"
              >
                <i class="el-icon-edit-outline" style="font-size: 20px;" />
              </el-button>
            </el-tooltip>

            <el-tooltip
              :content="$t('GlobalSetObj.Delete')" class="item" effect="dark"
              placement="top"
            >
              <el-popconfirm
                :title="$t('collectionCenter.deleteSure')"
                @confirm="tableDel(scope.row.id)"
              ><!-- 确定删除吗？ -->
                <i
                  slot="reference" v-permit:remove="'btn:basic-data:postal-code-management:del'"
                  class="el-icon-delete" style="font-size: 20px;"
                />
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="right">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          background
          style="margin: 10px 0"
          @current-change="search"
          @size-change="search1"
        />
      </div>
    </el-card>
    <!-- 新增 / 编辑 窗口 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogIsOpen"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
      @close="cloceDialog"
    >
      <el-form
        ref="formRef" :model="postalCodeList" size="small"
        class="addPostCon"
      >
        <el-row>
          <el-col :span="24">
            <!-- 州 -->
            <el-form-item
              :label="$t('mdfeTranslate.StateUF')" prop="state"
              :rules="[
                { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] }
              ]"
            >
              <el-select
                v-model="postalCodeList.state"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
                @change="getEditCity(postalCodeList.state)"
              >
                <el-option
                  v-for="(item, index) in twoCodeList"
                  :key="index"
                  :label="item.stateCode"
                  :value="item.stateCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 城市 -->
            <el-form-item
              :label="$t('collectionCenter.city')" prop="city"
              :rules="[
                { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] }
              ]"
            >
              <ElSelectV2
                v-model="postalCodeList.city"
                :options="allEditCity"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                filterable
                size="small"
                style="width: 100%"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- 区域类型 -->
          <el-form-item
            :label="$t('collectionCenter.regionType')"
            prop="areaType"
            :rules="[
              { required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] }
            ]"
          >
            <el-select
              v-model="postalCodeList.areaType"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              filterable
              size="small"
              style="width: 100%"
            >
              <el-option label="Capital" value="Capital" />
              <el-option label="Metropolitana" value="Metropolitana" />
              <el-option label="Interior 0" value="Interior 0" />
              <el-option label="Interior 1" value="Interior 1" />
              <el-option label="Interior 2" value="Interior 2" />
              <el-option label="Interior 3" value="Interior 3" />
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <!-- 风险区域 -->
          <el-form-item
            :label="$t('basicData.RiskAreas')"
            prop="riskArea"
            :rules="[{ required: true, message: $t('collectionCenter.notNull'), trigger: ['blur', 'change'] }]"
          >
            <el-select
              v-model="postalCodeList.riskArea"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              clearable
              filterable
              size="small"
              style="width: 100%"
            >
              <el-option :label="$t('GlobalSetObj.yes')" :value="1" />
              <el-option :label="$t('GlobalSetObj.No')" :value="0" />
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <!-- IBGE -->
          <el-form-item label="IBGE">
            <el-input v-model="postalCodeList.ibge" />
          </el-form-item>
        </el-row>
        <el-row>
          <!-- 添加邮编 -->
          <el-form-item
            :label="$t('collectionCenter.addPostcode')"
            prop="postcode"
            :rules="[
              { required: true, validator: validateZipCode, trigger: ['blur', 'change'] }
            ]"
          >
            <el-input
              v-if="dialogTitle === $t('collectionCenter.add')"
              v-model="postalCodeList.postcode" type="textarea" rows="6"
              style="width: 100%"
              :placeholder="$t('collectionCenter.postcodeFormatInstructions')"
            />
            <el-input v-else v-model="postalCodeList.postcode" />
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button type="info" size="small" @click="cloceDialog">{{ $t('collectionCenter.cancel') }}</el-button>
        <el-button type="primary" size="small" @click="submit">{{ $t('collectionCenter.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 导入窗口 -->
    <el-dialog
      :title="importTitle"
      :visible.sync="importIsOpen"
      width="45%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="cloceImportDialog"
    >
      <span class="import-title">{{ $t('collectionCenter.uploadPostalCodeFile') }}</span>
      <div class="upload-container">
        <el-upload
          ref="demoUpload"
          :before-upload="beforeUpload"
          :http-request="upLoad"
          :limit="1"
          action
          class="upload-demo"
          drag
        >
          <i class="el-icon-plus" style="margin: 25px auto 10px; font-size: 20px" />
          <!-- 点击或拖拽文件到此处上传 -->
          <div class="el-upload__text">{{ $t('collectionCenter.cldrUpload') }}</div>
        </el-upload>
      </div>
      <div style="font-size: 17px;margin: 20px 0 9px 50px">{{ $t('collectionCenter.importTemplateDownload') }}</div>
      <div class="templateDownloadClass" @click.stop="templateDownload">
        <span>{{ $t('collectionCenter.postalCodeTemplateDownload') }}</span>
        <span class="el-icon-download" />
      </div>

      <span slot="footer">
        <el-button type="info" size="small" @click="cloceImportDialog">{{ $t('collectionCenter.cancel') }}</el-button>
        <el-button type="primary" size="small" @click="submitImportFile">{{ $t('collectionCenter.submit') }}</el-button>
      </span>
    </el-dialog>
    <!--导入失败数据-->
    <el-dialog
      :title="$t('GlobalSetObj.ImportResults')"
      :visible.sync="isImportResults"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div style="display: flex;margin-bottom: 20px;">
        <div style="flex: 1">{{ $t('organizationManage.all') }}：{{ resultData.totalCount }}</div>
        <div style="flex: 1">{{ $t('organizationManage.succeed') }}：{{ resultData.successCount }}</div>
        <div style="flex: 1">{{ $t('operationCenter.fail') }}：{{ resultData.failCount }}</div>
      </div>
      <div v-if="resultData.errorFileUrl">
        <div style="margin-bottom: 10px;font-weight: bold">{{ $t('GlobalSetObj.ImportResults') }}：</div>
        <div style="color: #00A551;cursor: pointer">
          <span style="margin-right: 10px;" @click="downloadError">{{ $t('collectionCenter.ImportPostcodeResult') }}</span>
          <span @click="downloadError">{{ $t('GlobalSetObj.Download') }}</span>
        </div>
      </div>
      <span slot="footer">
        <el-button size="small" @click="isImportResults = false">{{ $t('collectionCenter.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStateCityList
} from '@/api/orderApi';
import {
  zipCodeManagePage,
  zipCodeManageAdd,
  zipCodeManageEdit,
  zipCodeManageDel,
  zipCodeManageExportAll,
  zipCodeManageImport
} from '@/api/lanshou';
import ElSelectV2 from 'el-select-v2';
import { Loading } from 'element-ui';
import { goRWExportList } from '@/utils/goExportList.js';
import { saveAs } from 'file-saver';
import { compressList } from '@/utils/zipcode.js';
const ExcelJS = require('exceljs');
export default {
  name: 'PostalCodeManagement',
  components: {
    ElSelectV2
  },
  data() {
    const validateZipCode = (rule, value, callback, index) => {
      if (!value) {
        return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
      }

      // 正则校验：只允许 0-9 数字、逗号(,)和波浪号(~)
      const regex = /^[0-9,~，]+$/;
      if (!regex.test(value)) {
        return callback(new Error(this.$t('collectionCenter.postalCodeFormat')));
      }

      // 使用正则表达式分割字符串，支持逗号和波浪号
      const segments = value.split(/[,，]/);

      for (let segment of segments) {
        segment = segment.trim();

        // 检查每个段是否是8位数字或有效的范围（如 10000000~20000000）
        if (segment.includes('~')) {
          // 处理范围格式：10000000~20000000
          const rangeParts = segment.split('~');

          if (rangeParts.length !== 2) {
            return callback(new Error(this.$t('collectionCenter.postalCodeFormat')));
          }

          const [start, end] = rangeParts;

          // 检查起始和结束是否都是8位数字
          if (!/^\d{8}$/.test(start) || !/^\d{8}$/.test(end)) {
            return callback(new Error(this.$t('collectionCenter.postalCodeFormat')));
          }

          // 检查起始值是否小于等于结束值
          if (parseInt(start) > parseInt(end)) {
            return callback(new Error(this.$t('collectionCenter.zipCodeRangeSizePrompts')));
          }
        } else {
          // 检查起始和结束是否都是8位数字
          if (!/^\d{8}$/.test(segment)) {
            return callback(new Error(this.$t('collectionCenter.postalCodeFormat')));
          }
        }
      }

      callback();
    };
    return {
      parsedDataList: [],
      validateZipCode: validateZipCode,
      twoCodeList: [],
      allCity: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          state: '',
          city: '',
          zipCode: '',
          areaType: ''
        }
      },
      total: 0,
      tableDate: [],
      dialogIsOpen: false,
      dialogTitle: '',
      postalCodeList: {
        state: '',
        city: '',
        postcode: '',
        ibge: '',
        riskArea: '',
        areaType: ''
      },
      importTitle: this.$t('collectionCenter.Import'),
      importIsOpen: false,
      importFile: new FormData(),
      isImportResults: false,
      resultData: {
        errorFileUrl: '',
        failCount: 0,
        successCount: 0,
        totalCount: 0
      },
      allEditCity: []
    };
  },
  created() {
    this.getSheng();
    this.default();
    this.search();
  },
  methods: {
    // 下载导入失败数据
    downloadError() {
      const link = document.createElement('a');
      link.style.display = 'none';

      // 假设 this.resultData.errorFileUrl 是一个有效的文件地址
      link.href = this.resultData.errorFileUrl;

      // 设置文件名（注意编码）
      const fileName = this.$t('collectionCenter.ImportPostcodeResult') + '.xlsx';
      link.download = encodeURIComponent(fileName);

      // 触发点击事件
      document.body.appendChild(link);
      link.click();

      // 清理 DOM 和 URL 对象
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    default() {
      this.queryForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          state: '',
          city: '',
          zipCode: '',
          areaType: ''
        }
      };
    },
    reset() {
      this.default();
      this.search1();
    },
    search1() {
      this.queryForm.pageNumber = 1;
      this.search();
    },
    search() {
      zipCodeManagePage(this.queryForm).then(res => {
        if (res.code === 200) {
          this.total = res.data.total;
          this.tableDate = res.data.records;
        }
      });
    },
    tableDel(id) {
      zipCodeManageDel(id).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('collectionCenter.DeleteSucceeded'));
          this.search();
        }
      });
    },
    exportAll() {
      const form = this.queryForm.params;
      zipCodeManageExportAll(form).then(res => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    newAdd() {
      this.dialogIsOpen = true;
      this.dialogTitle = this.$t('collectionCenter.add');
    },
    edit(row) {
      this.getEditCity(row.state);
      this.$nextTick(() => {
        this.postalCodeList = {
          id: row.id,
          state: row.state,
          city: row.city,
          postcode: row.startZipCodeStr + '~' + row.endZipCodeStr,
          ibge: row.ibge,
          riskArea: row.riskArea,
          areaType: row.areaType,
          version: row.version
        };
        this.dialogIsOpen = true;
        this.dialogTitle = this.$t('collectionCenter.edit');
      });
    },
    cloceDialog() {
      this.dialogIsOpen = false;
      this.postalCodeList = {
        state: '',
        city: '',
        postcode: '',
        ibge: '',
        riskArea: '',
        areaType: ''
      };
      this.allEditCity = [];
      this.$refs.formRef.resetFields();
    },
    submit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          if (this.dialogTitle === this.$t('collectionCenter.add')) {
            const zipcodeCollation = compressList(this.postalCodeList.postcode);
            const zipcodeArr = [];
            zipcodeCollation.forEach(item => {
              const itemArr = item.split('~');
              if (itemArr.length === 2) {
                const zipcode = {
                  startZipCodeStr: item.split('~')[0],
                  endZipCodeStr: item.split('~')[1]
                };
                zipcodeArr.push(zipcode);
              } else {
                const zipcode = {
                  startZipCodeStr: item.split('~')[0],
                  endZipCodeStr: item.split('~')[0]
                };
                zipcodeArr.push(zipcode);
              }
            });
            const dataToSubmit = {
              state: this.postalCodeList.state,
              city: this.postalCodeList.city,
              zipCodeList: zipcodeArr,
              ibge: this.postalCodeList.ibge,
              riskArea: this.postalCodeList.riskArea,
              areaType: this.postalCodeList.areaType
            };
            zipCodeManageAdd(dataToSubmit).then(res => {
              if (res.code === 200) {
                this.dialogIsOpen = false;
                this.$message.success(this.$t('collectionCenter.addSuccessful')); // '新增成功'
                this.search();
              }
            });
          }
          if (this.dialogTitle === this.$t('collectionCenter.edit')) {
            const zipcodeCollation = this.postalCodeList.postcode.split('~');
            let startZipCodeStr = null;
            let endZipCodeStr = null;
            if (zipcodeCollation.length === 2) {
              startZipCodeStr = zipcodeCollation[0];
              endZipCodeStr = zipcodeCollation[1];
            } else {
              startZipCodeStr = zipcodeCollation[0];
              endZipCodeStr = zipcodeCollation[0];
            }
            const dataToSubmit = {
              id: this.postalCodeList.id,
              state: this.postalCodeList.state,
              version: this.postalCodeList.version,
              city: this.postalCodeList.city,
              startZipCodeStr: startZipCodeStr,
              endZipCodeStr: endZipCodeStr,
              ibge: this.postalCodeList.ibge,
              riskArea: this.postalCodeList.riskArea,
              areaType: this.postalCodeList.areaType
            };
            zipCodeManageEdit(dataToSubmit).then(res => {
              if (res.code === 200) {
                this.dialogIsOpen = false;
                this.$message.success(this.$t('collectionCenter.ModificationSuccessful'));
                this.search();
              }
            });
          }
        } else {
          this.$message.error(this.$t('collectionCenter.checkFormFields'));
          return false;
        }
      });
    },

    importThis() {
      this.importIsOpen = true;
    },
    cloceImportDialog() {
      this.importIsOpen = false;
      this.importFile = new FormData();
      this.parsedDataList = [];
      if (this.$refs.demoUpload) {
        this.$refs.demoUpload.clearFiles();
      }
    },

    // 解析xlsx
    async parseExcelFile(file) {
      const wb = new ExcelJS.Workbook();
      const parsedData = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async() => {
          try {
            await wb.xlsx.load(reader.result);

            const worksheet = wb.worksheets[0];
            const data = [];

            const headerMapping = {
              '州 UF': 'state',
              '城市 Cidade': 'city',
              '开始邮编 Min ZipCode': 'startZipCode',
              '结束邮编 Max ZipCode': 'endZipCode',
              '区域类型 Tipe de Região': 'areaType',
              '风险区域 Área de risco (1：是(Sim); 0：否(Não))': 'riskArea',
              'IBGE': 'ibge'
            };

            worksheet.eachRow((row, rowNumber) => {
              if (rowNumber === 1) return;

              const rowData = {};
              row.eachCell((cell, colNumber) => {
                const originalHeader = worksheet.getRow(1).getCell(colNumber).text;
                const targetField = headerMapping[originalHeader];
                if (targetField) {
                  rowData[targetField] = cell.text || cell.value;
                }
              });

              data.push(rowData);
            });

            resolve(data);
          } catch (e) {
            reject(e);
          }
        };
        reader.onerror = () => {
          reject(new Error(this.$t('collectionCenter.fileReadFailed'))); // '文件读取失败'
        };
        reader.readAsArrayBuffer(file);
      });

      return parsedData;
    },
    // 导入
    async beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
      const whiteList = ['xlsx'];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // 上传文件只能是xlsx格式
        this.$message.error(this.$t('orderImport.uploadOnlyXlsx'));
        this.$refs.demoUpload.clearFiles();
        this.importFile = new FormData();
        this.parsedDataList = [];
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        // 上传文件大小不能超过 10MB
        this.$message.error(this.$t('collectionCenter.uploadNot10MB'));
        this.$refs.demoUpload.clearFiles();
        this.importFile = new FormData();
        this.parsedDataList = [];
        return false;
      }

      let parsedData = [];
      try {
        parsedData = await this.parseExcelFile(file);
        console.log('解析后的数据:', parsedData);

        if (!parsedData || parsedData.length === 0) {
          this.$message.warning(this.$t('collectionCenter.noParsableDataInFile')); // '文件中没有可解析的数据'
          this.$refs.demoUpload.clearFiles();
          this.importFile = new FormData();
          this.parsedDataList = [];
          return false;
        }

        if (parsedData.every(item => Object.keys(item).length === 0)) {
          this.$message.warning(this.$t('collectionCenter.emptyDataParsed')); // '解析到空数据，请检查文件内容是否符合模板'
          this.$refs.demoUpload.clearFiles();
          this.importFile = new FormData();
          this.parsedDataList = [];
          return false;
        }

        // 校验逻辑开始
        const zipRegex = /^[0-9]{8}$/;
        for (let i = 0; i < parsedData.length; i++) {
          const row = parsedData[i];
          const rowNumber = i + 1;

          // 必填字段校验
          if (!row.state || !row.city || !row.startZipCode || !row.endZipCode || !row.areaType || !row.riskArea) {
            //                      `第  行存在空字段，请检查数据完整性`
            this.$message.error(this.$t('collectionCenter.tips1') + rowNumber + this.$t('collectionCenter.tips1_1'));
            this.$refs.demoUpload.clearFiles();
            this.importFile = new FormData();
            this.parsedDataList = [];
            return false;
          }

          // 邮编格式校验
          if (!zipRegex.test(row.startZipCode) || !zipRegex.test(row.endZipCode)) {
            //                     `第  行邮编格式错误，需为8位纯数字`
            this.$message.error(this.$t('collectionCenter.tips1') + rowNumber + this.$t('collectionCenter.tip2'));
            this.$refs.demoUpload.clearFiles();
            this.importFile = new FormData();
            this.parsedDataList = [];
            return false;
          }

          // 起始邮编不能大于结束邮编
          if (row.startZipCode > row.endZipCode) {
            // `第 ${rowNumber} 行起始邮编不能大于结束邮编`
            this.$message.error(this.$t('collectionCenter.tips1') + rowNumber + this.$t('collectionCenter.tip3'));
            this.$refs.demoUpload.clearFiles();
            this.importFile = new FormData();
            this.parsedDataList = [];
            return false;
          }

          // 区域类型校验
          const areaTypeArr = ['Capital', 'Metropolitana', 'Interior 0', 'Interior 1', 'Interior 2', 'Interior 3'];
          if (!areaTypeArr.includes(row.areaType)) {
            // `第 ${rowNumber} 行区域类型必须为 CAP 或 INT`
            this.$message.error(this.$t('collectionCenter.tips1') + rowNumber + this.$t('collectionCenter.SelectedAreaTypeIncorrect'));
            this.$refs.demoUpload.clearFiles();
            this.importFile = new FormData();
            this.parsedDataList = [];
            return false;
          }

          // 邮编范围不能重复（内存中校验）
          // 邮编范围交集校验 - 只与前面的记录比较
          for (let j = 0; j < i; j++) {
            const existingRow = parsedData[j];
            const existingRowNum = j + 1;

            // 同州同城市的邮编范围才需要校验交集
            if (row.state === existingRow.state &&
              row.city === existingRow.city) {
              // 检查邮编范围是否重叠
              const currentStart = parseInt(row.startZipCode);
              const currentEnd = parseInt(row.endZipCode);
              const existingStart = parseInt(existingRow.startZipCode);
              const existingEnd = parseInt(existingRow.endZipCode);

              // 重叠条件: currentStart <= existingEnd && existingStart <= currentEnd
              if (currentStart <= existingEnd && existingStart <= currentEnd) {
                this.$message.error(
                  `${this.$t('collectionCenter.tips1')}${rowNumber}` +
                  `${this.$t('collectionCenter.tip5_1')}${existingRowNum}` +
                  `${this.$t('collectionCenter.tip5_2')}`
                );
                this.$refs.demoUpload.clearFiles();
                this.importFile = new FormData();
                this.parsedDataList = [];
                return false;
              }
            }
          }
        }
        this.parsedDataList = parsedData;
        return true;
      } catch (error) {
        this.$message.error(this.$t('collectionCenter.fileParseFailed')); // '文件解析失败'
        this.$refs.demoUpload.clearFiles();
        this.importFile = new FormData();
        this.parsedDataList = [];
        return false;
      }
    },
    async upLoad(option) {
      const lastIndex = option.file.name.lastIndexOf('.');
      const fileType = option.file.name.substring(lastIndex + 1);
      if (fileType === 'xlsx') {
        const files = option.file;
        const formData = new FormData();
        formData.append('file', files);
        this.importFile = formData;
      } else {
        this.importFile = new FormData();
        this.parsedDataList = [];
      }
    },
    submitImportFile() {
      if (this.parsedDataList && this.parsedDataList.length > 0) {
        const load = Loading.service({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: this.$t('spareNumberPoo.loading'),
          background: 'rgba(250, 250, 250, 0.6)'
        });
        zipCodeManageImport(this.importFile).then(res => {
          if (res.code === 200) {
            this.resultData = res.data;
            this.isImportResults = true;
          }
        }).finally(() => {
          load.close();
          this.cloceImportDialog();
        });
      } else {
        this.$message.warning(this.$t('collectionCenter.fileUploadMessage'));
      }
    },
    async templateDownload() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');

        // 定义列结构
        const columns = [
          { header: '州 UF', key: 'state', width: 20 },
          { header: '城市 Cidade', key: 'city', width: 25 },
          { header: '开始邮编 Min ZipCode', key: 'startZipCodeStr', width: 30 },
          { header: '结束邮编 Max ZipCode', key: 'endZipCodeStr', width: 30 },
          { header: '区域类型 Tipe de Região', key: 'areaType', width: 30 },
          { header: '风险区域 Área de risco (1：是(Sim); 0：否(Não))', key: 'riskArea', width: 30 },
          { header: 'IBGE', key: 'ibge', width: 20 }
        ];

        // 设置列（这会自动创建第一行作为标题）
        Sheet1.columns = columns;

        // 设置表头行样式（必须在 columns 设置之后立即处理）
        const headerRow = Sheet1.getRow(1);
        headerRow.height = 30;
        headerRow.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '00b050' } // 背景色 #00b050
          };
          cell.font = {
            color: { argb: '000' }, // 白色字体
            bold: true
          };
          cell.alignment = {
            horizontal: 'center',
            vertical: 'middle',
            wrapText: true
          };
        });

        // 创建下拉选项工作表并填充内容-区域类型
        const dropdownSheet = wb.addWorksheet('Dropdown');
        dropdownSheet.columns = [{ header: 'Option', key: 'option' }];
        dropdownSheet.addRows([
          { option: 'Capital' },
          { option: 'Metropolitana' },
          { option: 'Interior 0' },
          { option: 'Interior 1' },
          { option: 'Interior 2' },
          { option: 'Interior 3' }
        ]);
        dropdownSheet.state = 'veryHidden'; // 深度隐藏该sheet

        // 创建下拉选项工作表并填充内容-风险区域
        const dropdownSheet1 = wb.addWorksheet('Dropdown1');
        dropdownSheet1.columns = [{ header: 'Option', key: 'option' }];
        dropdownSheet1.addRows([
          { option: '1' },
          { option: '0' }
        ]);
        dropdownSheet1.state = 'veryHidden'; // 深度隐藏该sheet

        // 给第5列添加下拉数据验证
        for (let i = 2; i <= 10000; i++) {
          Sheet1.getCell(`E${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`=Dropdown!$A$2:$A$7`]
          };
          Sheet1.getCell(`F${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`=Dropdown1!$A$2:$A$3`]
          };
        }

        // 写入文件并下载
        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const fileName = `${that.$t('basicData.zipCode')}-${new Date().getTime()}.xlsx`;

        saveAs(blob, fileName);
      }
      ddd();
    },
    // 获取州
    getSheng() {
      const params = {
        type: 3,
        parentCode: '',
        name: ''
      };
      getStateCityList(params, false).then((res) => {
        if (res.code === 200) {
          this.twoCodeList = res.data;
        }
      });
    },
    // 获取城市
    getCity(state) {
      this.queryForm.params.city = '';
      let parentCode = '';
      this.twoCodeList.map(item => {
        if (item.stateCode === state) {
          parentCode = item.code;
        }
      });
      if (parentCode === '' || parentCode === null || parentCode === undefined) {
        this.allCity = [];
        return false;
      }
      const params = {
        type: 4,
        parentCode: parentCode,
        name: ''
      };
      getStateCityList(params, false).then((res) => {
        if (res.code === 200) {
          this.allCity = res.data.map(item => {
            return {
              label: item.namePu,
              value: item.namePu,
              id: item.id
            };
          });
        }
      });
    },
    // 编辑查询城市
    getEditCity(state) {
      this.postalCodeList.city = '';
      let parentCode = '';
      this.twoCodeList.map(item => {
        if (item.stateCode === state) {
          parentCode = item.code;
        }
      });
      if (parentCode === '' || parentCode === null || parentCode === undefined) {
        this.allEditCity = [];
        return false;
      }
      const params = {
        type: 4,
        parentCode: parentCode,
        name: ''
      };
      getStateCityList(params, false).then((res) => {
        if (res.code === 200) {
          this.allEditCity = res.data.map(item => {
            return {
              label: item.namePu,
              value: item.namePu,
              id: item.id
            };
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.import-title {
  display: inline-block;
  font-size: 17px;
  font-weight: bold;
  color: #000;
  margin-left: 50px;
  margin-bottom: 20px;
}
.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
  .upload-demo {
    width: 60%;
  }
}
.upload-container ::v-deep .el-upload-dragger {
  background-color: #f2f3f5;
  border: none;
  height: 110px;
}
::v-deep .el-dialog__title {
  color: #000;
  font-weight: bold;
}
.el-upload__text {
  font-size: 18px;
}
.selectClass ::v-deep .el-form-item__label {
  line-height: 24px !important;
}
.Box ::v-deep .el-divider {
  margin-top: 0 !important;
}
.Box{
  padding: 20px;
  box-sizing: border-box;
}
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.codeClass {
  color: #cc0000;
  font-size: 12px;
}
.templateDownloadClass {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #00A551;
  background: #f2f3f5;
  width: 70%;
  margin: 0 auto;
  padding: 5px 10px;
  border-radius: 2px;
  box-sizing: border-box;
  cursor: pointer;
}
</style>
<style>
.addPostCon .el-form-item__label {
  line-height: 20px !important;
}
</style>
